import { render, staticRenderFns } from "./StatsRecords.vue?vue&type=template&id=f40d2c86&scoped=true"
import script from "./StatsRecords.vue?vue&type=script&lang=js"
export * from "./StatsRecords.vue?vue&type=script&lang=js"
import style0 from "./StatsRecords.vue?vue&type=style&index=0&id=f40d2c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40d2c86",
  null
  
)

export default component.exports